import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
}))

export default styles
